<template>
  <div class="floating-quick-pick-button">
    <nav class="button-wrap flex justify-between items-center w-full h-full px-200 mx-auto">
      <LcButton
        class="button w-full shadow-card-large bg-primary-primary"
        icon="flash"
        no-padding
        size="large"
        variant="primary-ghost"
        @click="emit('click')"
      >
        <slot>
          {{ $t('lottery.quickpick.button') }}
        </slot>
      </LcButton>
    </nav>
  </div>
</template>

<script lang="ts" setup>
type Emits = {
  (event: 'click'): void
}
const emit = defineEmits<Emits>()
</script>

<style lang="scss" scoped>
.floating-quick-pick-button {
  position: fixed;
  right: 0;
  bottom: $main-bottom-navigation-height;
  left: 0;
  z-index: 50;
  width: 100%;
  height: $main-bottom-navigation-height;

  .button-wrap {
    max-width: $main-content-width;

    .button {
      border-color: token('color/background/primary/primary');
    }
  }
}
</style>
